export const selectTree = (state) => state.context.tree;
export const selectTreeIndex = (state) => state.context.index;
export const selectTreeLoading = (state) => state.context.loading;
export const selectNode = (state, id) => state.context.index[id];
